module.exports = __webpack_public_path__ + "img/hero-slider-1.5a1ef49d.jpg";